const rafThrottle = (fn) => {
  let ticking = false;

  return function (...args) {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      ticking = false;
      fn.apply(this, args);
    });
  };
};
const checkDiscountProductInCart = async function(id,discountcode){
  const response = await fetch("/cart.js");
  const data = await response.json();
  const matched = data.items.filter( item => item.id == id && (item.properties != null && item.properties._isFree == 1));
  return matched.length > 0 ? matched[0].key : false;
};
const removeProductIfDiscountNotExisit = async function(id,discountcode){
  const response = await fetch("/cart.js");
  const data = await response.json();
  const matched = data.items.filter( item => item.id == id && (item.properties != null && item.properties._isFree == 1));
  const discountMatched = data.items.filter( (item) => {
    return item.discounts.filter(discount => discount.title == discountcode).length > 0;
  });
  
  if(discountMatched.length > 0){
    if(matched.length <= 0){
       addRemoveDiscountProduct(id,1);
       document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }else{
     if(matched.length > 0){
        addRemoveDiscountProduct(matched[0].key,0);
       document.dispatchEvent(new CustomEvent('cart:build'));
     }
  }
}

const initCustomDiscountEvent = function() {
  const button = document.querySelector(".discount-apply-btn");
  const input = document.querySelector(".discount-input");

  if (!button || !input) return;

  const productId = button.dataset.id;
  const code = button.dataset.code;

  removeProductIfDiscountNotExisit(productId, code);

  if (!input.dataset.boundDiscountEnter) {
    input.dataset.boundDiscountEnter = "1";

    input.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();
        button.click();
      }
    });
  }

  if (!button.dataset.boundDiscountClick) {
    button.dataset.boundDiscountClick = "1";

    button.addEventListener("click", async function(e) {
      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      const button = e.currentTarget;
      const productId = e.currentTarget.dataset.id;
      const code = e.currentTarget.dataset.code;
      const enteredCode = document.querySelector(".discount-input").value;

      button.classList.add("btn--loading");

      let cartData = false;
      const discountProductOnCart = await checkDiscountProductInCart(productId, code);

      if (
        enteredCode.toLowerCase() == code.toLowerCase() &&
        productId != null &&
        productId != ""
      ) {
        if (discountProductOnCart == false) {
          cartData = await addRemoveDiscountProduct(productId, 1);
        }
      }

      setTimeout(async function() {
        await applyCustomDiscount(enteredCode, productId);

        setTimeout(async function() {
          const cartResponse = await fetch("/cart.js");
          const data = await cartResponse.json();

          const discountMatched = data.items.filter((item) => {
            return item.discounts.filter(
              (discount) => discount.title == enteredCode
            ).length > 0;
          });

          const matched = data.items.filter(
            (item) =>
              item.id == productId &&
              item.properties != null &&
              item.properties._isFree == 1
          );

          if (discountMatched.length <= 0 && matched.length > 0) {
            cartData = addRemoveDiscountProduct(matched[0].key, 0);
          }

          if (
            data.cart_level_discount_applications.length <= 0 &&
            discountMatched.length <= 0
          ) {
            document.querySelector(".custom-error-div")?.classList.remove("hidden");
          }

          button.classList.remove("btn--loading");

          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, "text/html");
              const selectors = ["cart-drawer-items", ".cart-drawer__footer"];

              for (const selector of selectors) {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }

              document.dispatchEvent(new CustomEvent("custom:updated"));
            })
            .catch((e) => {
              console.error(e);
            });
        }, 300);
      }, 500);
    });
  }
};

const updateCustomCartDrawer = async (cart,data) => {
  cart.renderContents(data);
  document.dispatchEvent(new CustomEvent('custom:updated'));
}
const addRemoveDiscountProduct = async function(id,qty){
   const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  if(qty == 1){
    let formData = {
     'items': [{
      'id': id,
      'quantity': qty,
       "properties":{
         "_isFree":1
       }
      }],
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
    return data;
    //document.dispatchEvent(new CustomEvent('cart:build'));
  }else{
    let formData = {
      'id': id,
      'quantity': 0,
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
     return data;
  }
  return true;
}
const applyCustomDiscount = async function(discountCode ,id){
  const checkoutUrl = `/checkout?discount=${discountCode}`;
  const response = fetch(checkoutUrl);
  return true;
}
const removeCustomDiscount = async function(discountCode){
  const checkoutUrl = `/checkout?discount=${discountCode}`;
  const response = fetch(checkoutUrl);
  return true;
}
const addSecondCrossProduct = async(id, isAdded, lineKey) => {
  console.log('[CATALOGUE] addSecondCrossProduct called — id:', id, 'isAdded:', isAdded, 'lineKey:', lineKey);
  const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");

  if (!cart) {
    console.error('[CATALOGUE] cart-drawer element not found!');
    return;
  }

  if (isAdded == 1) {
    let formData = {
      'items': [{ 'id': id, 'quantity': 1 }],
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };
    console.log('[CATALOGUE] POST /cart/add.js — formData:', JSON.stringify(formData));
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
    console.log('[CATALOGUE] add response status:', response.status, 'item_count:', data.item_count);

    if (data.status && data.status !== 200) {
      console.error('[CATALOGUE] API error:', data.message, data.description);
    }

    const inputEl = document.querySelector(".cart-drawer-second-cross-sell input");
    if (inputEl) {
      inputEl.setAttribute("data-isexist", "true");
      if (data.items && data.items[0]) {
        inputEl.setAttribute("data-key", data.items[0].key);
      }
    }

    updateCustomCartDrawer(cart, data);
  } else {
    // Retirer: récupérer tous les items du catalogue et les supprimer
    const csInput = document.querySelector(".cart-drawer-second-cross-sell input");
    const productId = csInput ? csInput.dataset.mainid : '';

    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();
    const updates = {};
    cartData.items.forEach(item => {
      if (item.product_id == productId) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0 && lineKey) {
      updates[lineKey] = 0;
    }

    console.log('[CATALOGUE] POST /cart/update.js — removing updates:', JSON.stringify(updates));

    let formData = {
      updates,
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });
    const data = await response.json();
    console.log('[CATALOGUE] remove response status:', response.status, 'item_count:', data.item_count);

    const inputEl = document.querySelector(".cart-drawer-second-cross-sell input");
    if (inputEl) {
      inputEl.setAttribute("data-isexist", "false");
      inputEl.setAttribute("data-key", "");
    }

    updateCustomCartDrawer(cart, data);
  }
}
const checkSecondCrossOnCart = async() => {
  if (document.querySelectorAll(".cart-drawer-second-cross-sell").length > 0) {
    const inputElement = document.querySelector(".cart-drawer-second-cross-sell input");
    if (!inputElement) return;

    let vid = inputElement.dataset.pid;
    let productId = inputElement.dataset.mainid;

    const response = await fetch("/cart.js");
    const data = await response.json();

    if (data.item_count > 0) {
      // Chercher tous les items du catalogue (les deux variants)
      const matched = data.items.filter(item => item.product_id == productId);
      if (matched.length > 0) {
        // Trouver l'item gratuit pour le data-key
        const freeItem = matched.find(item => item.id == vid) || matched[0];
        inputElement.setAttribute("data-isexist", "true");
        inputElement.setAttribute("data-key", freeItem.key);
        inputElement.checked = true;

        const banner = inputElement.closest('.cs-simple-banner');
        const checkmark = banner?.querySelector('.cs-checkmark');
        const arrow = banner?.querySelector('.cs-arrow-hint');
        if (checkmark) checkmark.classList.add('cs-checkmark--checked');
        if (arrow) arrow.style.display = 'none';

        // Ne pas cacher les lignes du catalogue — elles ont un custom qty control
        // (le CSS .hide-product s'en charge si on le veut, mais ici on les montre)
      } else {
        inputElement.setAttribute("data-isexist", "false");
        inputElement.setAttribute("data-key", "");
        inputElement.checked = false;

        const banner = inputElement.closest('.cs-simple-banner');
        const checkmark = banner?.querySelector('.cs-checkmark');
        const arrow = banner?.querySelector('.cs-arrow-hint');
        if (checkmark) checkmark.classList.remove('cs-checkmark--checked');
        if (arrow) arrow.style.display = '';
      }
    } else {
      inputElement.setAttribute("data-isexist", "false");
      inputElement.setAttribute("data-key", "");
      inputElement.checked = false;

      const banner = inputElement.closest('.cs-simple-banner');
      const checkmark = banner?.querySelector('.cs-checkmark');
      const arrow = banner?.querySelector('.cs-arrow-hint');
      if (checkmark) checkmark.classList.remove('cs-checkmark--checked');
      if (arrow) arrow.style.display = '';
    }
  }
};
const initSecondCrossSellCartEvent = () => {
  const input = document.querySelector(".cart-drawer-second-cross-sell input");
  if (!input) {
    console.log('[CATALOGUE] initSecondCrossSellCartEvent: no input found');
    return;
  }

  console.log('[CATALOGUE] initSecondCrossSellCartEvent: input found, data-pid:', input.dataset.pid, 'data-isexist:', input.dataset.isexist);

  if (input.dataset.boundCrossSellChange) {
    console.log('[CATALOGUE] already bound, skipping');
    return;
  }
  input.dataset.boundCrossSellChange = "1";

  input.addEventListener("change", async (evt) => {
    console.log('[CATALOGUE] === CHANGE EVENT FIRED ===');
    console.log('[CATALOGUE] checked:', evt.target.checked);
    console.log('[CATALOGUE] dataset.isexist:', evt.target.dataset.isexist);
    console.log('[CATALOGUE] dataset.pid:', evt.target.dataset.pid);
    console.log('[CATALOGUE] dataset.key:', evt.target.dataset.key);
    console.log('[CATALOGUE] dataset.mainid:', evt.target.dataset.mainid);

    let vid = evt.target.dataset.pid;
    let lineKey = evt.target.dataset.key || '';
    let isExist = evt.target.dataset.isexist;

    // Mise à jour visuelle immédiate
    const banner = evt.target.closest('.cs-simple-banner');
    const checkmark = banner?.querySelector('.cs-checkmark');
    const arrow = banner?.querySelector('.cs-arrow-hint');

    if (evt.target.checked) {
      console.log('[CATALOGUE] checkbox is CHECKED — should ADD product');
      if (checkmark) checkmark.classList.add('cs-checkmark--checked');
      if (arrow) arrow.style.display = 'none';

      // FIX: comparer avec == au lieu de === pour gérer "false" et false
      if (isExist == false || isExist === "false" || isExist === "") {
        console.log('[CATALOGUE] calling addSecondCrossProduct with vid:', vid);
        try {
          await addSecondCrossProduct(vid, 1);
        } catch (err) {
          console.error('[CATALOGUE] error in addSecondCrossProduct:', err);
        }
      } else {
        console.log('[CATALOGUE] NOT adding — isExist is already true');
      }
    } else {
      console.log('[CATALOGUE] checkbox is UNCHECKED — should REMOVE product');
      if (checkmark) checkmark.classList.remove('cs-checkmark--checked');
      if (arrow) arrow.style.display = '';

      if (isExist == true || isExist === "true") {
        console.log('[CATALOGUE] calling addSecondCrossProduct to remove, lineKey:', lineKey);
        try {
          await addSecondCrossProduct(vid, 0, lineKey);
        } catch (err) {
          console.error('[CATALOGUE] error in addSecondCrossProduct (remove):', err);
        }
      } else {
        console.log('[CATALOGUE] NOT removing — isExist is already false');
      }
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initSecondCrossSellCartEvent();
  initCustomDiscountEvent();
  checkSecondCrossOnCart();
  initCatalogueBanner();
  initCatalogueQuantityControls();

  let cartUpdateTimer;

  const reinitCartUi = function () {
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(() => {
      checkSecondCrossOnCart();
      initCustomDiscountEvent();
      initSecondCrossSellCartEvent();
      initCatalogueBanner();
      initCatalogueQuantityControls();
    }, 120);
  };

  document.addEventListener("custom:updated", reinitCartUi);

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, reinitCartUi);
  }
});

const loadInfinateLoader = (() => {
  let ajaxinateInitialized = false;
  let ajaxinateRetryCount = 0;
  const ajaxinateMaxRetries = 20;
  let ajaxinateRetryTimer = null;

  function initAjaxinate() {
    if (ajaxinateInitialized) return true;

    const productGrid = document.querySelector("#product-grid");
    const pagination = document.querySelector("#AjaxinatePagination");

    if (!productGrid || !pagination) return false;
    if (!pagination.querySelector("a[href]")) return false;
    if (typeof Ajaxinate !== "function") return false;

    ajaxinateInitialized = true;

    new Ajaxinate({
      container: "#product-grid",
      pagination: "#AjaxinatePagination",
      loadingText: `<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>`,
      callback: function () {
        setTimeout(() => {
          customCollectionEventsInit();
          initlizeCustomButtonsEvents();
        }, 500);
      }
    });

    return true;
  }

  return function loadInfinateLoader() {
    if (initAjaxinate()) {
      if (ajaxinateRetryTimer) {
        clearTimeout(ajaxinateRetryTimer);
        ajaxinateRetryTimer = null;
      }
      return;
    }

    if (ajaxinateRetryCount >= ajaxinateMaxRetries) return;
    if (ajaxinateRetryTimer) return;

    ajaxinateRetryCount += 1;
    ajaxinateRetryTimer = setTimeout(() => {
      ajaxinateRetryTimer = null;
      loadInfinateLoader();
    }, 300);
  };
})();

function extractDiscountPercentage(text) {
    const percentageMatch = text.match(/(\d+)\s?%/);
    if (percentageMatch) {
        return parseFloat(percentageMatch[1]);
    }
    return null;
}
function change_price(){
   let compareElement = document.querySelector('.checked-item .comapre_m');
    let lastPriceElement = document.querySelector('.product__info-wrapper .price-item--sale');
    let savingsPercentElement = document.querySelector('.product__info-wrapper .savings-percent');
    if (compareElement && lastPriceElement && savingsPercentElement) {
        if (lastPriceElement.innerText.trim() === "") {
            console.error('Error: last price element is empty');
            return;
        }
        let comparePrice = parseFloat(compareElement.innerText.replace('€', '').replace(',', '.').trim());
        let lastPrice = parseFloat(lastPriceElement.innerText.replace('€', '').replace(',', '.').trim());
        if (isNaN(comparePrice) || isNaN(lastPrice)) {
            console.error('Error parsing prices: comparePrice or lastPrice is NaN');
            return;
        }
        let savingsPercent = ((comparePrice - lastPrice) / comparePrice) * 100;
        let roundedSavingsPercent = Math.round(savingsPercent);
        savingsPercentElement.innerText = '-' + roundedSavingsPercent + '%';
    } else {
        console.error('One or more elements not found');
    }
}
jQuery(document).ready(function($){
  initDeferredSliders();

  $(document).on("click", "details.menu-drawer-container.menu-opening", function(e) {
    // Check if the click was on the main details element and not its children
    if ($(e.target).is(this)) {
        $(this).removeAttr("open");
    }
    $('body').removeClass('body-submenu-open');
});
  
  $(document).on("change",`.shopify_subscriptions_app_block_label input[type="radio"]`,$.proxy(function(){
   // Select the elements
    let compareElement = document.querySelector('.checked-item .comapre_m');
    if(!compareElement){
    const original = $("product-info .savings-percent").data("original");
    const percentage = extractDiscountPercentage(this.ariaLabel);
    if(percentage != null ){
     $("product-info .savings-percent").text(`-${percentage}%`);
    }else{
       $("product-info .savings-percent").text(`-${original}%`);
    }
      }else{
   change_price();
      }
  }));

  $(document).on("click",".custom-popup-opener",function(){
     $(`.custom-modal__centered.active`).removeClass("active");
    $(`body`).addClass("custom-model-open");
      const dataId = $(this).data("id");
      $(`.custom-modal__centered[data-id="${dataId}"]`).addClass("active");
  });
  $(document).on("click",".custom-popup-opener-a",function(){
     $(`.custom-modal__centered.active`).removeClass("active");
    $(`body`).addClass("custom-model-open");
      const dataId = $(this).data("id");
      $(`.custom-modal__centered[data-id="${dataId}"]`).addClass("active");
  });
  
   $(document).on("click",".custom-modal__close",function(){
     $(`.custom-modal__centered.active`).removeClass("active");
     $(`body`).removeClass("custom-model-open");

  });
  
  $(document).on("click",".custom-filter-box ",function(){
      $(".custom-filter-box").removeClass("active");
      $(this).addClass("active");
      const dataId = $(this).data("id");
     const isClickedFirst = $(this).hasClass("first-class");
     
      $(".filter-items").each( function(){
        if(isClickedFirst){
           $(".filter-items").removeClass("hide").slideDown(); 
        }else{
          if($(this).attr("id") != dataId){
            $that = $(this);
            $(this).slideUp(function(){
              $that.addClass("hide");
            });
          }else{
            $(this).removeClass("hide");
            $(this).slideDown();
          }
        }
        
      });
      
    }); 
  $(document).on("change",".custom-swatch-element .custom-swatch-radio",function(){
    const mainElement = $(this).parents(".custom-swatches-new-wrapper");
    mainElement.find(".custom-swatch-element").removeClass("checked-item");
    $(this).parent(".custom-swatch-element").addClass("checked-item"); 
  });

  $(document).on("change",".custom-review-tab-selector",function(){
    setTimeout(function(){
      window.dispatchEvent(new Event("resize"));
    },500);
  });
  
  function initDeferredSliders() {
  const start = () => {
    if (
      $('.custom-offer-announcement .utility-bar__grid').length > 0 &&
      !$('.custom-offer-announcement .utility-bar__grid').hasClass('slick-initialized')
    ) {
      $('.custom-offer-announcement .utility-bar__grid').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 6000,
        pauseOnHover: false,
        cssEase: 'linear',
        arrows: false,
        dots: false,
        responsive: [
          { breakpoint: 1200, settings: { speed: 6000 } },
          { breakpoint: 992, settings: { speed: 4000 } },
          { breakpoint: 768, settings: { speed: 2000 } },
          { breakpoint: 480, settings: { speed: 1000 } }
        ]
      });
    }

    if (
      $('.trust-slider').length > 0 &&
      !$('.trust-slider').hasClass('slick-initialized')
    ) {
      $('.trust-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1280,
            settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true }
          },
          {
            breakpoint: 1024,
            settings: { slidesToShow: 2, slidesToScroll: 2, infinite: true }
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 2, slidesToScroll: 2 }
          },
          {
            breakpoint: 480,
            settings: { slidesToShow: 1, slidesToScroll: 1 }
          }
        ]
      });
    }
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(start, { timeout: 1200 });
  } else {
    setTimeout(start, 700);
  }
}
  
  if($('.trust-slider').length > 0){
     $('.trust-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  adaptiveHeight: true,    
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  }

   

     $(document).on("click",".collapsible-accordion summary",function(e){
       e.preventDefault();
        $('.collapsible-accordion .accprdomg_main').not($(this).parent()).removeClass('active');
        $('.collapsible-accordion .accordion-main').not( $(this).next()).slideUp();
       $(this).parent().toggleClass('active');
        $(this).next().slideToggle();
      });
   $('etrusted-rc-carousel-review-tile').hide();
   $('etrusted-rc-carousel-review-tile [rating="5"]').parents('etrusted-rc-carousel-review-tile').show();
   if(document.querySelectorAll("#ProductGridContainer").length > 0){
    loadInfinateLoader();
  }
  // $( "ul.mega-menu__list.page-width > li" ).hover(function() {
  //    // $(this).siblings().find('ul').css('display','none');
  //    $(this).find('ul').css('display','grid');
  // });
  
    const body = document.body;
  const header = document.querySelector("header");
  const newsletterBar = document.querySelector(".newsleter-bar");
  let lastScrollTop = 0;
  const headerTop = header ? header.offsetTop : 0;

  window.addEventListener(
    "scroll",
    rafThrottle(function () {
      const st = window.scrollY || window.pageYOffset;

      if (header && st > headerTop) {
        body.classList.add("sticky-header");
        if (newsletterBar) newsletterBar.classList.add("active");
      }

      if (st > lastScrollTop && st < 500) {
        body.classList.remove("another-sticky-header");
        if (newsletterBar) newsletterBar.classList.remove("active");
      }

      if (st < lastScrollTop && st > 500) {
        body.classList.add("another-sticky-header");
        if (newsletterBar) newsletterBar.classList.add("active");
      }

      if (st === 0) {
        body.classList.remove("sticky-header");
        body.classList.remove("another-sticky-header");
        if (newsletterBar) newsletterBar.classList.remove("active");
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }),
    { passive: true }
  );

  // $(document).on("click", ".accordion.content-container details summary", function () {
  //     $(this).parent('details').parent().siblings().children().removeAttr('open');
  // });
});

function recommendationAddProductToCart(evt) {
  const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  const submitButton = evt.currentTarget;
  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  submitButton
    .querySelector(".loading__spinner")
    .classList.remove("hidden");
  const mainId = submitButton.dataset.vid;
  let items = [
    {
      id: mainId,
      quantity: 1,
    },
  ];
  let formData = {
    items: items,
    sections: cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname,
  };
  fetch(`${routes.cart_add_url}.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: mainId,
          errors: response.description,
          message: response.message,
        });

        const soldOutMessage = submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        submitButton.setAttribute("aria-disabled", true);
        submitButton.querySelector("span").classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: mainId,
      });
      cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove("loading");
      if (cart && cart.classList.contains("is-empty"))
        cart.classList.remove("is-empty");
      submitButton.removeAttribute("aria-disabled");
      submitButton
        .querySelector(".loading__spinner")
        .classList.add("hidden");
    });
}

var reinitCustomAddtoCartButtons = function () {
  document.querySelectorAll(".recommandaion-product-add").forEach((el) => {
    if (el.dataset.boundRecommendationAdd) return;
    el.dataset.boundRecommendationAdd = "1";
    el.addEventListener("click", recommendationAddProductToCart);
  });
};
var loadProductRecommendationsIntoSectionCart = function () {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(
    ".product-recommendations-cart"
  );
  if (productRecommendationsSection === null) {
    return;
  }

  // Read vars from attributes
  var productId = productRecommendationsSection.dataset.productId;
  var limit = productRecommendationsSection.dataset.limit;
  var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
  var prod_thumb_img_ratio =
    productRecommendationsSection.dataset.prod_thumb_img_ratio;

  // Build request URL
  var requestUrl =
    productRecommendationsSection.dataset.url +
    "?section_id=product-recommendation-cart&limit=" +
    limit +
    "&product_id=" +
    productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      
      productRecommendationsSection.innerHTML = new DOMParser()
        .parseFromString(request.response, "text/html")
        .querySelector(".product-recommendations-cart").innerHTML;
      reinitCustomAddtoCartButtons();
      // set correct image shape
      
    }
  };
  request.send();
};

if(window.location.href == "https://www.naturaforce.com/pages/programme-fidelite"){
  setTimeout(() => {
  }, 3000);
}
theme.Shopify = {
  formatMoney: function formatMoney(t, r) {
    function e(t, r) {
      return void 0 === t ? r : t;
    }
    function a(t, r, a, o) {
      if (
        ((r = e(r, 2)), (a = e(a, ",")), (o = e(o, ".")), isNaN(t) || null == t)
      )
        return 0;
      t = (t / 100).toFixed(r);
      var n = t.split(".");
      return (
        n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
        (n[1] ? o + n[1] : "")
      );
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      i = r || this.money_format;
    switch (i.match(n)[1]) {
      case "amount":
        o = a(t, 2);
        break;
      case "amount_no_decimals":
        o = a(t, 0);
        break;
      case "amount_with_comma_separator":
        o = a(t, 2, ".", ",");
        break;
      case "amount_with_space_separator":
        o = a(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        o = a(t, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        o = a(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        o = a(t, 0, " ", "");
        break;
      case "amount_with_apostrophe_separator":
        o = a(t, 2, "'", ".");
        break;
      case "amount_with_decimal_separator":
        o = a(t, 2, ".", ".");
    }
    return i.replace(n, o);
  },
};
if (!customElements.get('simple-progress-bar')) {
  customElements.define(
    'simple-progress-bar',
    class SimpleProgressBar extends HTMLElement {
      constructor() {
        super();

        this.t1 = this.dataset.t1 ? (+this.dataset.t1 * Shopify.currency.rate) : 0;
        this.t2 = this.dataset.t2 ? (+this.dataset.t2 * Shopify.currency.rate) : 0;
        this.t3 = this.dataset.t3 ? (+this.dataset.t3 * Shopify.currency.rate) : 0;
        this.t4 = this.dataset.t4 ? (+this.dataset.t4 * Shopify.currency.rate) : 0;
        this.t5 = this.dataset.t5 ? (+this.dataset.t5 * Shopify.currency.rate) : 0;
        
        
        this.giftProducts = this.dataset.t1products;
        this.gift2Products = this.dataset.t2products;
        this.gift3Products = this.dataset.t3products;
        this.gift4Products = this.dataset.t4products;
        this.gift5Products = this.dataset.t5products;

        this.t1MatchedProducts = [];
        this.t2MatchedProducts = [];
        this.t3MatchedProducts = [];
        this.t4MatchedProducts = [];
        this.t5MatchedProducts = [];
        
        this.totalMatchedCart = [];
        this.productIds = [];

         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        this.updateThresholdPriceBox();
        this.init();
      }
      
      calculatePercentage(amount) {
        let percentage = 0;
        let next_goal;
        const thresholds = [this.t1, this.t2, this.t3, this.t4, this.t5].filter(t => t > 0);
        const thresholds_areas = thresholds.length + 1;
        let next_threshold = 1;

        for (let i = 0; i < thresholds.length; i++) {
          if (amount < thresholds[i]) {
            next_goal = thresholds[i];
            next_threshold = i + 1;
            break;
          } else {
            next_goal = thresholds[i];
            next_threshold = i + 1;
          }
        }

        if (amount >= thresholds[thresholds.length - 1]) {
          percentage = 100;
        } else {
          let threshold_distance = (100 / thresholds_areas);
          let completed_thresholds_distance = ((next_threshold - 1) * threshold_distance);
          percentage = ((amount * 1.0) / next_goal * threshold_distance) + completed_thresholds_distance;
          percentage = percentage - 4;
        }

        return percentage;
      }
      updateThresholdPriceBox() {
        if (this.t1 > 0) this.querySelector(`.position-bar-box-container[data-number="1"] .price-box`).textContent = theme.Shopify.formatMoney((this.t1 * 100), "{{amount_no_decimals}} €");
        if (this.t2 > 0) this.querySelector(`.position-bar-box-container[data-number="2"] .price-box`).textContent = theme.Shopify.formatMoney((this.t2 * 100), "{{amount_no_decimals}} €");
        if (this.t3 > 0) this.querySelector(`.position-bar-box-container[data-number="3"] .price-box`).textContent = theme.Shopify.formatMoney((this.t3 * 100), "{{amount_no_decimals}} €");
        if (this.t4 > 0) this.querySelector(`.position-bar-box-container[data-number="4"] .price-box`).textContent = theme.Shopify.formatMoney((this.t4 * 100), "{{amount_no_decimals}} €");
        if (this.t5 > 0) this.querySelector(`.position-bar-box-container[data-number="5"] .price-box`).textContent = theme.Shopify.formatMoney((this.t5 * 100), "{{amount_no_decimals}} €");
      }
      async init() {
          const thresholds = [this.t1, this.t2, this.t3, this.t4, this.t5].filter(t => t > 0);
          let giftItems = [
            this.giftProducts,
            this.gift2Products,
            this.gift3Products,
            this.gift4Products,
            this.gift5Products,
          ];
          const tMatchedProducts = Array(5).fill([]);
          this.totalMatchedCart = [];
          this.productIds = [];
          const tGifItems = giftItems.map(gift => (gift != "" ? gift.split("___") : []));
          let progressBar1 = this.querySelector("#cprogressbar1");
         
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          this.totalMatchedCart = cart.items.filter(item => item.properties._isGift == 1);
          let giftPrice = 0;
          const totalGiftProduct = this.findItemInCart(cart,[]);
          if (totalGiftProduct.length > 0) {
            this.totalMatchedCart = totalGiftProduct;
            giftPrice = totalGiftProduct.reduce((total, item) => total + item.final_line_price, 0);
          }
          const cartTotalIncent = (cart.total_price - giftPrice);
          const cartTotal = cartTotalIncent/100;
          let percentage = this.calculatePercentage(cartTotal);
          this.needToRemoved=[];

          let nextThresholdIndex = thresholds.findIndex(threshold => (cartTotal < threshold));
          nextThresholdIndex = nextThresholdIndex === -1 ? thresholds.length : nextThresholdIndex;

          const sippingAmount = nextThresholdIndex < thresholds.length ? (thresholds[nextThresholdIndex] * 100 - cartTotalIncent) : 0;

          if (nextThresholdIndex > 0) {
            const previousThresholdIndex = nextThresholdIndex - 1;
            this.productIds = this.prepareProductIdForCart(tGifItems[previousThresholdIndex], this.findItemInCart(cart, tGifItems[previousThresholdIndex]));
            if(tGifItems[previousThresholdIndex].length > 0){
              this.needToRemoved = this.findDeletedItems(cart, tGifItems[previousThresholdIndex]);
            }
            
          } else {
            this.needToRemoved = this.findDeletedItems(cart, []);
          }
          this.updateMessage(nextThresholdIndex, sippingAmount);
          if (this.needToRemoved.length > 0) {
            let updates = this.needToRemoved.reduce((acc, { key, quantity }) => {
              acc[key] = 0;
              return acc;
            }, {});
            this.removeGifts(updates, this.productIds.length <= 0);
          }
          if (this.productIds.length > 0) {
            this.addGifts(this.productIds, 1);
          }
          
          if (Shopify.currency.active != 'EUR') {
            progressBar1.style.width = `${percentage}%`;
          }
          
         
      }
      prepareProductIdForCart(giftItems,matchedItems){
        let productIds = [];
         if(giftItems.length > 0 && matchedItems.length <= 0){
          for(let i in giftItems){
              productIds.push(giftItems[i]);
          }
        }else if(giftItems.length > 0 && matchedItems.length > 0 &&  giftItems.length != matchedItems.length){
          for(let i in giftItems){
              const giftProductId = +giftItems[i];
              const isAdded = matchedItems.filter(item1 => item1.id == giftProductId && item1.properties._isGift == 1);
              if(isAdded.length <= 0){
                productIds.push(giftItems[i]);
              }
          }
        }
        return productIds;
      }
      findItemInCart(cart,products){
         if(products.length > 0){
          return cart.items.filter(item => products.includes(`${item.id}`) && item.properties._isGift == 1 );
         }else{
           return cart.items.filter(item => item.properties._isGift == 1 );
         }
      }
      findDeletedItems(cart,excludeProducts){
        if(excludeProducts.length > 0){
          return this.totalMatchedCart.filter(item => excludeProducts.includes(`${item.id}`) == false && item.properties._isGift == 1);
        }
        return this.totalMatchedCart.filter(item => item.properties._isGift == 1);
      }
      updateMessage(t, amount) {
        const messages = this.querySelectorAll(".progressbar-threshold-message");
        const progressBars = this.querySelectorAll(".position-bar-box-container");
         const thresholds = [this.t1, this.t2, this.t3, this.t4, this.t5].filter(t => t > 0);
      
        // Hide all messages and deactivate all progress bars initially
        messages.forEach(el => el.classList.add("hide"));
        progressBars.forEach(el => el.classList.remove("activated"));
      
        if (typeof t === 'undefined' || t >= thresholds.length) {
          // Show success message if no threshold is provided or all thresholds are reached
          messages.forEach(el => {
            if (el.classList.contains("success-t")) {
              el.classList.remove("hide");
            }
          });
          progressBars.forEach(el => el.classList.add("activated"));
        } else {
          if(t <= 0){
            messages.forEach(el => {
                if (el.classList.contains(`t1`)) {
                  el.classList.remove("hide");
                  el.querySelector(".custom-amount").textContent = theme.Shopify.formatMoney(amount, theme.money_format);
                }
              });
          }else{
            // Show specific threshold message
              messages.forEach(el => {
                if (el.classList.contains(`t${t+1}`)) {
                  el.classList.remove("hide");
                  el.querySelector(".custom-amount").textContent = theme.Shopify.formatMoney(amount, theme.money_format);
                }
              });
              progressBars.forEach(el => {
                if (Number(el.dataset.number) <= t) {
                  el.classList.add("activated");
                }
              });
          }
          
        }
      }
      removeGifts(updates,isUpdate){
          const body = JSON.stringify({
            updates,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          });
          fetch(`/cart/update.js`,{
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: body
            })
            .then((response) => response.json())
            .then((response) => {
               if(isUpdate == true){
                if(window.location.pathname == '/cart'){
                   window.location.reload(true);
                  return;
                }
                  const cartDrawerWrapper = document.querySelector('cart-drawer');
                  if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', response.item_count === 0);
                 this.cart.renderContents(response);
              }
          });
        
      }
      addGifts(productIds,isUpdate){
        let items = [];
          items = productIds.map((id) => {
            return {
              "id":id,
              "quantity":1,
              "properties":{
                "_isGift":1
              }
           };
          });
          let formData = {
           'items':items,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          };
          fetch(`/cart/add.js`,{
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then((response) => response.json())
          .then((response) => {
           
              if(isUpdate == 1){
                if(window.location.pathname == '/cart'){
                  window.location.reload(true);
                  return;
                }
                 publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: this.productIds[0],
                });
                
                this.cart.renderContents(response);
              }
          });  
       }
     }
  );
}
function checkAttributeAndModifyStyles(targetElement) {
    const headerSearch = targetElement;
    if (headerSearch) {
        if (!headerSearch.hasAttribute('open')) {
            const collectionSwatchSection = document.querySelector('.collection-swatch-section__wrapper');
            const home_page_section = document.querySelector('#shopify-section-template--16202326048815__image_banner_BWCRgf');
            if (collectionSwatchSection) {
                collectionSwatchSection.style.marginTop = '66px';
            }
            else if (home_page_section) {
                home_page_section.style.marginTop = '65px';
            }
        }
    }
}
 window.addEventListener("scroll", rafThrottle(function () {
  if (
    document.body.classList.contains("index") ||
    document.body.classList.contains("collection")
  ) {
    var targetElement = document.querySelector(".header__search details");

    if (window.innerWidth < 1100) {
      // checkAttributeAndModifyStyles(targetElement);
    }

    if (window.scrollY > 10 && targetElement) {
      targetElement.setAttribute("open", "true");
    }
  }
}), { passive: true });

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
     this.endDate = new Date(this.getAttribute('end-date'));
  }

  updateCountdown() {
    const now = new Date();
    const timeRemaining = new Date(this.endDate) - new Date(now);

    if (timeRemaining <= 0) {
      // Countdown has ended, hide the element
      this.style.display = "none";
      document.querySelector(".countdown-wrapper").style.display="none";
    } else {
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      let hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      this.querySelector(".days-counter").innerHTML = String(days).padStart(2, '0');
      this.querySelector(".hours-counter").innerHTML = String(hours).padStart(2, '0');
      this.querySelector(".minutes-counter").innerHTML = String(minutes).padStart(2, '0');
      this.querySelector(".seconds-counter").innerHTML = String(seconds).padStart(2, '0');
    }
  }
  addHTML(){
     this.innerHTML = `
        <div class="timer-item days-item"><span class="small-size">J</span><span class="days-counter">${String(0).padStart(2, '0')}</span></div>
        <div class="timer-item colon-item"><span>:</span></div>
        <div class="timer-item hours-item"><span class="small-size">H</span><span class="hours-counter">${String(0).padStart(2, '0')}</span></div>
        <div class="timer-item colon-item"><span>:</span></div>
        <div class="timer-item minutes-item"><span class="small-size">M</span><span class="minutes-counter">${String(0).padStart(2, '0')}</span></div>
        <div class="timer-item colon-item"><span>:</span></div>
        <div class="timer-item seconds-items"><span class="small-size">S</span><span class="seconds-counter">${String(0).padStart(2, '0')}</span></div>`;
    
  }
  connectedCallback() {
    this.addHTML();
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define("countdown-timer", CountdownTimer);
document.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll('.product__title a[href^="#"]');

  links.forEach((link) => {
    if (link.dataset.boundSmoothAnchor) return;
    link.dataset.boundSmoothAnchor = "1";

    link.addEventListener("click", function(event) {
      event.preventDefault();

      const href = this.getAttribute("href");
      if (!href || href === "#") return;

      const targetID = href.substring(1);
      const targetElement = document.getElementById(targetID);

      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: "smooth"
        });
      }
    });
  });
});
document.querySelectorAll('.custom-header-mega-menu-left-part li a').forEach(link => {
    link.addEventListener('mouseenter', function() {
       document.querySelectorAll('.custom-header-mega-menu-right-part-child').forEach(child => {
            child.classList.remove('active');
        });
        const targetClass = this.getAttribute('data-target');
        document.querySelector('.' + targetClass).classList.add('active');
    });
});
const child = document.querySelector('.custom-header-mega-menu-child-wrapper');
    if (child) {
        child.addEventListener('mouseenter', function() {
            const parent = this.closest('.mega-menu');
            if (parent) {
                parent.classList.add('menu_hover');
                parent.setAttribute('open',true);
            }
        });
    }

document.addEventListener("DOMContentLoaded", (event) => {

 subscribe(PUB_SUB_EVENTS.variantChange, function(evt){
   if(evt.data.variant){
     if(document.querySelectorAll(".custom-variant-images-div").length > 0){
       if(document.querySelectorAll(`.custom-variant-images-div .customvimage[data-vid="${evt.data.variant.id}"]`).length > 0){
         const ImageUrl = document.querySelector(`.custom-variant-images-div .customvimage[data-vid="${evt.data.variant.id}"]`).dataset.src;
         document.querySelectorAll(".custom-swatch-element .image_coll img").forEach((el) => {
           el.src=ImageUrl;
         })
       }
     }
   }
 });
   if(document.querySelectorAll(".custom-variant-images-div").length > 0){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
     const variantId = urlParams.get("variant");
     if(variantId != null && variantId != ""){
        if(document.querySelectorAll(`.custom-variant-images-div .customvimage[data-vid="${variantId}"]`).length > 0){
         const ImageUrl = document.querySelector(`.custom-variant-images-div .customvimage[data-vid="${variantId}"]`).dataset.src;
         document.querySelectorAll(".custom-swatch-element .image_coll img").forEach((el) => {
           el.src=ImageUrl;
         })
       }
     }
   }

    function initAppstleUi() {
    let done = false;

    const widget = document.querySelector(".appstle_sub_widget");
    const labelsGroups = document.querySelectorAll(".shopify_subscriptions_app_block_label_children");

    if (widget) {
      const giftBlock = document.querySelector(".custom-subscription-gift-block");
      const buttonsWrapper = document.querySelector(".product-form__buttons .appstle_sub_widget");

      if (
        giftBlock &&
        buttonsWrapper &&
        !buttonsWrapper.nextElementSibling?.classList?.contains("custom-subscription-gift-block")
      ) {
        const giftblockClone = giftBlock.cloneNode(true);
        giftblockClone.classList.remove("hidden");
        giftBlock.remove();
        buttonsWrapper.after(giftblockClone);
      }

      done = true;
    }

    if (labelsGroups.length > 0) {
      labelsGroups.forEach((el) => {
        el.querySelectorAll("li").forEach((li, index) => {
          const label = li.querySelector("label");
          const defaultText =
            index === 1
              ? "Livraison tous les 3 mois, -20% dès la 2ème livraison"
              : "Livraison mensuelle, -20% dès la 2ème livraison";

          if (label && label.childNodes[2] && label.childNodes[2].nodeType === Node.TEXT_NODE) {
            label.childNodes[2].nodeValue = defaultText;
          }
        });
      });

      done = true;
    }

    return done;
  }

  if (!initAppstleUi()) {
    const appstleObserver = new MutationObserver(() => {
      if (initAppstleUi()) {
        appstleObserver.disconnect();
      }
    });

    appstleObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => appstleObserver.disconnect(), 5000);
  }

  
});

 if($(".collection-swatch-section__content").length > 0 && $(".collection-swatch-section__content .story-card.active").length > 0){
    const acItem = document.querySelector(".collection-swatch-section__content .active");
    let tabwidth = acItem.offsetWidth;
    acItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  
         // Function to generate dynamic IDs from header text and add event listeners
         function addDynamicIdsAndLinks() {
            const headers = document.querySelectorAll('.page .rte.scroll-trigger h2,.page .rte.scroll-trigger h3,.page .rte.scroll-trigger h4');
            const navList = document.getElementById('dynamic-nav');
            const dynamic_nav_wrapper = document.querySelector('.dynamic_nav_wrapper');
            let currentUl = navList;
            let lastHeaderLevel = 2;
            if(headers.length == 0 && dynamic_nav_wrapper){
              dynamic_nav_wrapper.remove();
            }
            headers.forEach(header => {
                // Generate a dynamic ID based on the text content
                const textContent = header.textContent.trim();
                const dynamicId = textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
                header.id = dynamicId;

                // Create a list item with a link
                const listItem = document.createElement('li');
                const link = document.createElement('a');
                link.href = '#' + dynamicId;
                link.textContent = textContent;
                listItem.appendChild(link);

                // Adjust list nesting based on header level
                const headerLevel = parseInt(header.tagName.charAt(1));
                if (headerLevel > lastHeaderLevel) {
                    const newUl = document.createElement('ul');
                    currentUl.lastElementChild.appendChild(newUl);
                    currentUl = newUl;
                } else if (headerLevel < lastHeaderLevel) {
                    currentUl = navList;
                    for (let i = 2; i < headerLevel; i++) {
                        currentUl = currentUl.lastElementChild.lastElementChild;
                    }
                }

                currentUl.appendChild(listItem);
                lastHeaderLevel = headerLevel;
            });
        }
         function toggleNav() {
            const dynamicNav = document.getElementById('dynamic-nav');
            dynamicNav.style.display = (dynamicNav.style.display === 'none' || dynamicNav.style.display === '') ? 'block' : 'none';
        }
        // Call the function to add dynamic IDs and links on page load
        document.addEventListener('DOMContentLoaded', addDynamicIdsAndLinks);
document.addEventListener('click', function(event) {
            if (event.target.tagName === 'A' && event.target.hash !== '') {
                event.preventDefault();
                const targetId = event.target.hash.substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop,
                        behavior: 'smooth'
                    });
                }
            }
        });





    var waitForElement = function (selector, trigger, delayInterval, delayTimeout) {
      var interval = setInterval(function () {
        if (
          document &&
          document.querySelector(selector) &&
          document.querySelectorAll(selector).length > 0
        ) {
          clearInterval(interval);
          trigger();
        }
      }, delayInterval);
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    function getParameters(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    var init = function () {
      var promo = getParameters('camp');
      if(promo.indexOf("packs") > -1) {
        var reco = document.querySelector(".feature-product-bg");
        if (typeof (reco) != 'undefined' && reco != null) {
          var ttl = document.querySelector(".collection_title");
          ttl.insertAdjacentElement("afterend", reco);
          document.querySelector('[data-section-type="collection-swatches"]').style.display = "none";
          document.querySelector('.search-modal').style.display = "none";
          sessionStorage.setItem("packs-discount", "ON");
          document.querySelector(".custom-announcementbar-slider").style.display = "block";
        }
      }
    }

    waitForElement(".collection-title", init, 300, 4000);

    if(sessionStorage.getItem("packs-discount") == "ON") {
      document.querySelector(".custom-announcementbar-slider").style.display = "block";
    }
const changeRewardsText = function(){
   document.querySelector(".appstle-loyalty-billing-cycle span sup").textContent="ère";
   document.querySelector(".appstleLoyaltyTable td").innerHTML = document.querySelector(".appstleLoyaltyTable td").innerHTML.replace("Après","Après la")
}
waitForElement('.appstle_loyalty_title', changeRewardsText, 300, 4000);

document.addEventListener('StartAsyncLoading',function(event){
  setTimeout(function() {
    new Swiper('.collection-menu-slider', {
        loop: true, // Enable loop
        spaceBetween: 5,
        slidesPerView: 'auto', // Show 3 slides at a time
        autoplay: {
            delay: 3000, // Slide every 3 seconds
            // disableOnInteraction: false, // Keep autoplay working even after user interacts
        },
        speed: 600, // Set transition speed to 600ms for smooth scroll
        pagination: {
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1920: {
                spaceBetween: 5,
                slidesPerView: 'auto', // Show 3 slides on larger screens
            },
            1028: {
                spaceBetween: 5,
                slidesPerView: 'auto', // Show 3 slides on medium screens
            },
            767: {
                spaceBetween: 5,
                slidesPerView: 'auto', // Show 1 slide on smaller screens
            },
            0: {
                spaceBetween: 5,
                slidesPerView: 'auto', // Show 1 slide on mobile
            }
        }
    });
    }, 500);
});

function customCollectionEventsInit() {
  document.querySelectorAll(".custom-variant-select-box").forEach((el) => {
    if (el.dataset.boundVariantSelect) return;
    el.dataset.boundVariantSelect = "1";

    el.addEventListener("change", (evt) => {
      const select = evt.currentTarget;
      const mainGridElement = select.closest(".grid__item");
      if (!mainGridElement) return;

      const selectedId = select.value;

      mainGridElement.querySelectorAll(".custom-pack-grid-variant-price").forEach((priceEl) => {
        priceEl.classList.toggle("hidden", priceEl.dataset.vid !== selectedId);
      });

      mainGridElement.querySelectorAll(".custom-pack-info-base-on-variant").forEach((infoEl) => {
        infoEl.classList.toggle("hidden", infoEl.dataset.vid !== selectedId);
      });
    });
  });

  document.querySelectorAll(".custom-variant-selection-item input").forEach((input) => {
    if (input.dataset.boundVariantChoice) return;
    input.dataset.boundVariantChoice = "1";

    input.addEventListener("change", (evt) => {
      const currentInput = evt.currentTarget;
      const mainElement = currentInput.closest(".custom-hover-wrapper");
      if (!mainElement) return;

      const selectedId = currentInput.value;

      mainElement.querySelectorAll(".price-wrapper").forEach((el) => {
        el.classList.toggle("hidden", el.dataset.vid !== selectedId);
      });

      mainElement.querySelectorAll(".custom-subscription-item .price-block").forEach((el) => {
        el.classList.toggle("hidden", el.dataset.vid !== selectedId);
      });
    });
  });
}

  document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".custom-upsell-add").forEach((el) => {
    if (el.dataset.boundUpsellAdd) return;
    el.dataset.boundUpsellAdd = "1";
    el.addEventListener("click", recommendationAddProductToCart);
  });

$('.close-icon').on("click", function() {
  //$("#Details-menu-drawer-container").removeClass("menu-opening");
  $("body").removeClass("overflow-hidden-tablet");
  $("body").removeClass("body-submenu-open");
  $("#Details-menu-drawer-container").removeAttr("open");
});

$(".chat-box-button").on('click', function(){
    //$('button#Avada-FAQ_WidgetTrigger').click();
    open_chat_custom();
});
$("ul.menu-drawer__menu.has-submenu.list-menu li .menu-drawer__menu-item").on('click', function() {
  // Calculate the scroll position to make the menu item 42px from the top of the container
  var scrollToPosition = $(".menu-drawer__navigation-container").offset().top - $('div#menu-drawer').offset().top + 42;
  if(scrollToPosition <= 0){
    // Animate the scroll
    $('div#menu-drawer').animate({
      scrollTop: scrollToPosition
    }, 300);
  }

  // Delay adding the class until after the animation finishes
  setTimeout(() => {
    $('div#menu-drawer').addClass('sub-menu-open');
  }, 300); // Adjusted timeout to match animation duration
});

$(".desktop-menu-drawer-container .childlink-block .childlink-blocks").on('click', function(){
    $('.menu-drawer').removeClass('sub-menu-open');
    //console.log("ffff");
});

}); // ferme le DOMContentLoaded ouvert à la ligne 1524 — CORRIGÉ

document.addEventListener('StartAsyncLoading',function(event){
  var $desktopMenu = $('.menu-drawer__navigation.desktop .menu-drawer__menu.has-submenu ').clone(true);
  $('#link-complements-alimentaires .menu-drawer__inner-submenu').append($desktopMenu);

  $(".menu-drawer__navigation.mobile ul.menu-drawer__menu.has-submenu.list-menu li details details").on('click', function() {
    document.body.scrollTop = 0;
    $(this).addClass('menu-opening mobile-menu-open');
    $(this).attr('open');
  });  
    
  $(".menu-drawer__navigation.mobile ul.menu-drawer__menu.has-submenu.list-menu li details details .menu-drawer__close-button").on('click', function(){
    $(".mobile-menu-open").removeAttr('open');
    $(".mobile-menu-open").removeAttr('class');
  }); 

  setTimeout(() => {
      if(window.innerWidth > 991){
        document.querySelectorAll(".menu-drawer__navigation li.active details").forEach((el) => {  
          const buttonClose = el.querySelector(".menu-drawer__close-button");
           buttonClose.setAttribute("disabled","disabled");
          el.setAttribute('open',true);
          el.classList.add('menu-opening');
        });
      }
  },200);
  
});


$(document).ready(function() {
  if($(".timer-icon-width-text h6").length > 0){
    // Example usage
    const inputText = $(".timer-icon-width-text h6").html();
    const updatedText = replaceTextBasedOnTime(inputText);
    $(".timer-icon-width-text h6").html(updatedText);
  }
});

const finalCountdownEl = document.getElementById("the-final-countdown");

if (finalCountdownEl) {
  setInterval(() => {
    const d = new Date();
    let hours = 24 - d.getHours();
    let min = 60 - d.getMinutes();
    let sec = 60 - d.getSeconds();

    if ((min + "").length === 1) min = "0" + min;
    if ((sec + "").length === 1) sec = "0" + sec;

    finalCountdownEl.textContent = hours + "h " + min + "min " + sec + "sec";
  }, 1000);
}

function replaceTextBasedOnTime(text) {
    const now = new Date();
    const franceTime = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: 'numeric' }).format(now);
    
    if (parseInt(franceTime, 10) < 13) {
        return text.replace(/demain matin/g, "aujourd'hui");
    }
    return text;
}
document.addEventListener("DOMContentLoaded", function () {
  lightGallery(document.getElementById("swiper-container"), {
      speed: 500,
      plugins: [lgZoom],
      selector: ".swiper-slide a"
  });
  lightGallery(document.getElementById("swiper-containers"), {
      speed: 500,
      plugins: [lgZoom],
      selector: ".swiper-slide a"
  });
});

function initlizeCustomButtonsEvents() {
  document.querySelectorAll(".custom-hover-opner").forEach((button) => {
    if (button.dataset.boundHoverOpen) return;
    button.dataset.boundHoverOpen = "1";

    button.addEventListener("click", () => {
      const mainElement = button.closest(".grid__item");
      if (!mainElement) return;

      const hoverWrapper = mainElement.querySelector(".custom-hover-wrapper");
      const hoverHide = mainElement.querySelector(".hover-hide");

      if (hoverHide) hoverHide.style.visibility = "hidden";
      if (hoverWrapper) hoverWrapper.style.display = "flex";
    });
  });

  document.querySelectorAll(".custom-hover-closer-button").forEach((button) => {
    if (button.dataset.boundHoverClose) return;
    button.dataset.boundHoverClose = "1";

    button.addEventListener("click", () => {
      const mainElement = button.closest(".grid__item");
      if (!mainElement) return;

      const hoverWrapper = mainElement.querySelector(".custom-hover-wrapper");
      const hoverHide = mainElement.querySelector(".hover-hide");

      if (hoverHide) hoverHide.style.visibility = "visible";
      if (hoverWrapper) hoverWrapper.style.display = "none";
    });
  });

  document
    .querySelectorAll(".custom-modal__centered.bundle-price-main-modal-main-element")
    .forEach((modal) => {
      if (modal.dataset.boundModalOverlay) return;
      modal.dataset.boundModalOverlay = "1";

      modal.addEventListener("click", (event) => {
        if (event.target === modal) {
          modal.classList.remove("active");
        }
      });
    });
}

// Initialize the observer when the page is ready
document.addEventListener('DOMContentLoaded', () => {
    initlizeCustomButtonsEvents();

  subscribe(PUB_SUB_EVENTS.variantChange, function(evt){
     if(window.Samita && window.Samita.Wholesale && window.Samita.Wholesale.product){
        window.Samita.Wholesale.product.variants.map((variant) => {
          if(variant.finalPrice){
            const mainElement = document.querySelector(`.custom-swatch-element[data-variantid="${variant.id}"] label`);
            if(mainElement){
              const boitDevision = +mainElement.dataset.bdivision;
              const priceDevision = (variant.finalPrice / boitDevision).toFixed(2);
              const priceHtml = `${priceDevision}€/boite`;
             mainElement.querySelector('.price-block span').textContent = priceHtml;
              
            }
          }
        });
      }
   });
  
  // Wait a short time to ensure all elements are loaded
  if(document.body.classList.contains("product")){
    const samitaAppInterval = setInterval(() => {
      if(window.Samita && window.Samita.Wholesale && window.Samita.Wholesale.product && window.Samita.Wholesale.summaries && window.Samita.Wholesale.summaries.length > 0 && window.Samita.Wholesale.summaries[0].summary && window.Samita.Wholesale.summaries[0].summary.id){
       const appliedId = window.Samita.Wholesale.summaries[0].summary.id;
       
        /*window.Samita.Wholesale.product.variants.map((variant) => {
          console.log(variant,"variant");
          if(variant.finalPrice){
            const mainElement = document.querySelector(`.custom-swatch-element[data-variantid="${variant.id}"] label`);
            if(mainElement){
              const boitDevision = +mainElement.dataset.bdivision;
              const priceDevision = (variant.finalPrice / boitDevision).toFixed(2);
              const priceHtml = `${priceDevision}€/boite`;
             mainElement.querySelector('.price-block span').textContent = priceHtml;
              
            }
          }
        });*/
        window.Samita.Wholesale.product.id
        const wholeSaleItem = window.Samita.Wholesale.wholesalePricing[window.Samita.Wholesale.summaries[0].summary.id].configs.discount_for_variants.filter(item => item.id == window.Samita.Wholesale.product.id);
        if(wholeSaleItem.length > 0){
          wholeSaleItem[0].variants.map((variant) => {
           
            const pVariant = window.Samita.Wholesale.product.variants.filter(v => v.id == variant.id);
             
            if(variant.discount_groups){
              const mainElement = document.querySelector(`.custom-swatch-element[data-variantid="${variant.id}"] label`);
              if(mainElement && pVariant.length > 0){
                const discountedPrice = Number(variant.discount_groups[0].value) * 100;
                const finalPrice = (pVariant[0].price - discountedPrice) / 100;
                const boitDevision = +mainElement.dataset.bdivision;
                const priceDevision = (finalPrice / boitDevision).toFixed(2);
                const priceHtml = `${priceDevision}€/boite`;
               mainElement.querySelector('.price-block span').textContent = priceHtml;
                
              }
            }
          });
        }                              
        if(document.querySelector(`body[samitaws-element="handle"]`)){
          clearInterval(samitaAppInterval);
        }
        
      }
    },3000);
  }
});

if(document.body.classList.contains('bfcm-vip-success')) {
  document.querySelector('.klaviyo-form button[type="button"]').addEventListener('click', function () {
   klaviyo.track('Clicked Whatsapp Share');
  });
}
window.addEventListener('load', function() {
    const sectionElement = document.querySelector(".custom-nv-collection-swatches");
    if(sectionElement){
        const acItem = sectionElement.querySelector(".story-card.eg-active");
        if(acItem){
          let tabwidth = acItem.offsetWidth;
          sectionElement.querySelector(".eg-tabs-nav__position").style.cssText = '--width:' + tabwidth + 'px;--prevWidth:' + (acItem.offsetLeft) + 'px;';
          acItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        
    }
});
class CountDownStorage extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    const rawTime = this.getAttribute('data-time'); // "H-MM-SS"
    const useStorage = this.getAttribute('data-storage') === "true";
    const compId = this.getAttribute('id');

    if (!rawTime || !compId) return;

    const initialSeconds = this.parseTimeToSeconds(rawTime);

    let remaining = initialSeconds;

    // Recuperar del sessionStorage si corresponde
    if (useStorage) {
      const saved = sessionStorage.getItem(`countdown-${compId}`);
      if (saved !== null) {
        remaining = parseInt(saved, 10);
      }
    }

    this.render(remaining);

    this.interval = setInterval(() => {
      if (remaining <= 0) {
        this.render(0);
        clearInterval(this.interval);
        return;
      }

      remaining--;

      if (useStorage) {
        sessionStorage.setItem(`countdown-${compId}`, remaining);
      }

      this.render(remaining);
    }, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  parseTimeToSeconds(str) {
    const [h, m, s] = str.split('-').map(n => parseInt(n, 10) || 0);
    return (h * 3600) + (m * 60) + s;
  }

  formatTime(seconds) {
    const h = Math.floor(seconds / 3600);                 // sin cero delante
    const m = Math.floor((seconds % 3600) / 60)
                .toString().padStart(2, '0');             // siempre 2 dígitos
    const s = (seconds % 60).toString().padStart(2, '0'); // siempre 2 dígitos
    return `${h}:${m}:${s}`;
  }

  render(seconds) {
    this.textContent = this.formatTime(seconds);
  }
}
customElements.define('count-down-storage', CountDownStorage);

class CountDownStorage2 extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.getAttribute("data-time")).getTime();
    this.targetElementId = this.dataset.target;
    //this.shadow = this.attachShadow({ mode: "open" });
  }

  updateCountdown() {
    const now = new Date().getTime();
    const timeRemaining = this.endTime - now;

    if (timeRemaining <= 0) {
      // Countdown has ended, hide the element
      this.style.display = "none";
      //this.closest('.gradient').style.display="none";
      const targetElement = document.querySelector(`.${this.targetElementId}`);
      if(targetElement){
        targetElement.style.display="none";
      }
    } else {
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      /*this.innerHTML = `
        <div class="timer-item days-item"><span>${String(days).padStart(2, '0')}</span><span class="small-size">days</span></div>
        <div class="timer-item hours-item"><span>${String(hours).padStart(2, '0')}</span><span class="small-size">hours</span></div>
        <div class="timer-item minutes-item"><span>${String(minutes).padStart(2, '0')}</span><span class="small-size">minutes</span></div>
        <div class="timer-item seconds-items"><span>${String(seconds).padStart(2, '0')}</span><span class="small-size">seconds</span></div>
      `;*/
      this.innerHTML = `${String(days).padStart(2, '0')}:${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
   
    }
  }
  addHTML(){
    this.innerHTML = `00:00:00:00`;
  }
  connectedCallback() {
    this.addHTML();
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define("count-down-storage-2", CountDownStorage2);

function closeFilterForm(){
  //document.querySelector(".mobile-facets__disclosure").removeAttribute('open');
  document.querySelector(".mobile-facets__disclosure .mobile-facets__open-wrapper").dispatchEvent(new Event('click'))
}

/* Bloc dupliqué supprimé — l'initialisation se fait dans le DOMContentLoaded unique plus haut */

/* ============================================================
   CATALOGUE BANNER — Synchronisation visuelle
   ============================================================ */
function initCatalogueBanner() {
  document.querySelectorAll('.cs-simple-banner').forEach(function(banner) {
    if (banner.dataset.csInit) return;
    banner.dataset.csInit = 'true';

    const checkbox = banner.querySelector('.cross-sell-toggle');
    const checkmark = banner.querySelector('.cs-checkmark');
    const arrow = banner.querySelector('.cs-arrow-hint');

    if (!checkbox || !checkmark) return;

    if (checkbox.checked) {
      checkmark.classList.add('cs-checkmark--checked');
      if (arrow) arrow.style.display = 'none';
    } else {
      checkmark.classList.remove('cs-checkmark--checked');
      if (arrow) arrow.style.display = '';
    }
  });
}

/* ============================================================
   CATALOGUE QUANTITY — Gestion quantité 2 variantes
   Logique: 1er gratuit (variant 0€), 2e-50e à 1€ (variant payant)
   ============================================================ */

const CATALOGUE_MAX_QTY = 50;

const updateCatalogueQuantity = async (wrapper, action) => {
  console.log('[CATALOGUE] updateCatalogueQuantity called:', action);
  const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  if (!cart) { console.error('[CATALOGUE] cart element not found'); return; }

  const valueSpan = wrapper.querySelector('.catalogue-qty-value');
  let currentQty = parseInt(wrapper.dataset.totalQty || (valueSpan ? valueSpan.textContent : '1'), 10) || 1;
  console.log('[CATALOGUE] currentQty from DOM:', currentQty);

  if (action === 'plus') {
    if (currentQty >= CATALOGUE_MAX_QTY) { console.log('[CATALOGUE] max reached'); return; }
    currentQty++;
  } else if (action === 'minus') {
    if (currentQty <= 1) { console.log('[CATALOGUE] min reached'); return; }
    currentQty--;
  } else if (action === 'remove') {
    currentQty = 0;
  }

  console.log('[CATALOGUE] target qty:', currentQty);

  const csInput = document.querySelector('.cart-drawer-second-cross-sell input');
  const freeVariantId = csInput ? csInput.dataset.pid : '';
  const paidVariantId = csInput ? csInput.dataset.paidVid : '';
  const productId = csInput ? csInput.dataset.mainid : '';

  console.log('[CATALOGUE] freeVariantId:', freeVariantId, 'paidVariantId:', paidVariantId, 'productId:', productId);

  if (!freeVariantId) { console.error('[CATALOGUE] freeVariantId is empty!'); return; }

  const sections = cart.getSectionsToRender().map((section) => section.id);

  // Récupérer l'état actuel du panier
  const cartRes = await fetch('/cart.js');
  const cartData = await cartRes.json();

  // Trouver tous les items du catalogue dans le panier
  const existingItems = cartData.items.filter(item => item.product_id == productId);
  console.log('[CATALOGUE] existing catalogue items:', existingItems.length);

  let freeInCart = null;
  let paidInCart = null;
  existingItems.forEach(item => {
    if (item.variant_id == freeVariantId) freeInCart = item;
    else if (paidVariantId && item.variant_id == paidVariantId) paidInCart = item;
  });

  console.log('[CATALOGUE] freeInCart:', freeInCart ? freeInCart.key : 'NO', 'paidInCart:', paidInCart ? paidInCart.key : 'NO');

  if (currentQty === 0) {
    // Retirer tous les variants du catalogue
    const updates = {};
    if (freeInCart) updates[freeInCart.key] = 0;
    if (paidInCart) updates[paidInCart.key] = 0;

    console.log('[CATALOGUE] removing all, updates:', updates);

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, sections, sections_url: window.location.pathname })
    });
    const data = await response.json();
    console.log('[CATALOGUE] remove response received, item_count:', data.item_count);

    if (csInput) {
      csInput.setAttribute('data-isexist', 'false');
      csInput.setAttribute('data-key', '');
      csInput.checked = false;
      const banner = csInput.closest('.cs-simple-banner');
      const checkmark = banner?.querySelector('.cs-checkmark');
      const arrow = banner?.querySelector('.cs-arrow-hint');
      if (checkmark) checkmark.classList.remove('cs-checkmark--checked');
      if (arrow) arrow.style.display = '';
    }

    updateCustomCartDrawer(cart, data);
    return;
  }

  const freeQty = 1;
  const paidQty = currentQty - 1;
  let updates = {};
  let needsFreeAdd = false;
  let needsPaidAdd = false;

  if (currentQty === 1) {
    if (freeInCart) updates[freeInCart.key] = 1;
    else needsFreeAdd = true;
    if (paidInCart) updates[paidInCart.key] = 0;
  } else {
    if (freeInCart) updates[freeInCart.key] = freeQty;
    else needsFreeAdd = true;
    if (paidInCart) updates[paidInCart.key] = paidQty;
    else if (paidVariantId) needsPaidAdd = true;
  }

  console.log('[CATALOGUE] updates:', updates, 'needsFreeAdd:', needsFreeAdd, 'needsPaidAdd:', needsPaidAdd);

  // Étape 1: Appliquer les updates (changements de quantité et suppressions)
  let data;
  if (Object.keys(updates).length > 0) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, sections, sections_url: window.location.pathname })
    });
    data = await response.json();
    console.log('[CATALOGUE] update response, item_count:', data.item_count);
  }

  // Étape 2: Ajouter les variants manquants
  if (needsPaidAdd && paidVariantId) {
    console.log('[CATALOGUE] adding paid variant:', paidVariantId, 'qty:', paidQty);
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: paidVariantId, quantity: paidQty }],
        sections, sections_url: window.location.pathname
      })
    });
    data = await addResponse.json();
    console.log('[CATALOGUE] paid add response, item_count:', data.item_count);
  }

  if (needsFreeAdd && freeVariantId) {
    console.log('[CATALOGUE] adding free variant:', freeVariantId, 'qty:', freeQty);
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: freeVariantId, quantity: freeQty }],
        sections, sections_url: window.location.pathname
      })
    });
    data = await addResponse.json();
    console.log('[CATALOGUE] free add response, item_count:', data.item_count);
  }

  // Mettre à jour le data-key du checkbox
  const freshCart = await fetch('/cart.js');
  const freshData = await freshCart.json();
  const freeItem = freshData.items.find(item => item.variant_id == freeVariantId);
  if (freeItem && csInput) {
    csInput.setAttribute('data-key', freeItem.key);
    csInput.setAttribute('data-isexist', 'true');
  }

  if (data) updateCustomCartDrawer(cart, data);
};

const initCatalogueQuantityControls = () => {
  document.querySelectorAll('.catalogue-qty-wrapper').forEach(wrapper => {
    if (wrapper.dataset.bound) return;
    wrapper.dataset.bound = '1';

    wrapper.querySelectorAll('.catalogue-qty-btn, .catalogue-qty-remove').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const action = btn.dataset.action;
        await updateCatalogueQuantity(wrapper, action);
      });
    });
  });
};




/* ===== Appstle Subscription : permettre de decocher "S'abonner" =====
   L'option "Acheter une fois" etant masquee, on permet de revenir a l'achat
   unique en recliquant sur l'option d'abonnement deja cochee.
   pointerdown + click en capture : on bascule vers l'achat unique ET on
   bloque le clic natif qui suivrait (sinon le radio se re-coche).
   Les clics sur le select de frequence sont IGNORES (sinon la liste
   deroulante declencherait la bascule). */
(function() {
  function initAppstleToggle() {
    var w = document.querySelector('[id^=appstle_subscription_widget]');
    if (!w) return;
    var subOpt = w.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown');
    if (!subOpt) return;
    if (subOpt.getAttribute('data-nf-toggle')) return;
    subOpt.setAttribute('data-nf-toggle', '1');
    var switching = false;
    subOpt.addEventListener('pointerdown', function(e) {
      // Ignorer les clics sur le select de frequence (ne pas decocher)
      if (e.target && e.target.closest && e.target.closest('select')) return;
      var subRadio = subOpt.querySelector('input[name=selling_plan]');
      if (!subRadio || !subRadio.checked) return; // pas coche -> laisser le clic normal cocher
      switching = true;
      e.preventDefault();
      e.stopPropagation();
      var oneRadio = w.querySelector('input[name=selling_plan][value=""]');
      if (oneRadio) {
        oneRadio.checked = true;
        oneRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    // Bloque le clic natif qui suit la bascule (sinon le radio se re-coche)
    subOpt.addEventListener('click', function(e) {
      if (e.target && e.target.closest && e.target.closest('select')) return;
      if (switching) {
        switching = false;
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }
  initAppstleToggle();
  var mo = new MutationObserver(function() { initAppstleToggle(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* ===== Appstle Subscription : transmettre le selling_plan au formulaire d'ajout =====
   Le widget Appstle est rendu dans un shopify-block HORS du formulaire d'ajout
   au panier (form[action$="/cart/add"], ici le singleProductPreOrderForm de Globo).
   Appstle n'injecte donc pas le selling_plan -> le produit est ajoute SANS
   abonnement. Ce script copie la valeur du plan selectionne dans un input
   cache "selling_plan" du formulaire quand l'abonnement est coche, et le
   retire quand on decoche. */
(function() {
  function syncSellingPlan() {
    var w = document.querySelector('[id^=appstle_subscription_widget]');
    if (!w) return;
    // Ne jamais toucher au selling_plan des produits en precommande : le plan Globo
    // (Full Payment) est gere a part et ce sync le supprimerait (widget Appstle sur one-time).
    if (document.body && document.body.classList.contains('preorder-product')) return;
    var form = document.querySelector('form[action$="/cart/add"]');
    if (!form) return;
    // Ne transmettre le selling_plan QUE si le radio d'abonnement (valeur non vide) est coche.
    // Le select a toujours une valeur par defaut -> ne jamais l'utiliser comme fallback,
    // sinon l'abonnement serait active meme sans etre coche.
    var subRadio = w.querySelector('input[name="selling_plan"]:checked');
    var planId = subRadio && subRadio.value ? subRadio.value : null;
    var existing = form.querySelector('input[name="selling_plan"]');
    if (planId) {
      if (!existing) {
        existing = document.createElement('input');
        existing.type = 'hidden';
        existing.name = 'selling_plan';
        form.appendChild(existing);
      }
      existing.value = planId;
    } else if (existing) {
      existing.remove();
    }
  }
  document.addEventListener('change', function(e) {
    if (e.target && e.target.name === 'selling_plan') syncSellingPlan();
    if (e.target && e.target.classList && e.target.classList.contains('appstle_select')) syncSellingPlan();
  }, true);
  var mo = new MutationObserver(function() { syncSellingPlan(); });
  mo.observe(document.body, { childList: true, subtree: true });
  syncSellingPlan();
})();















/* ===== Appstle Subscription : widget fiable apres navigation =====
   La navigation entre produits (AJAX) insere le helper block Appstle mais
   n'execute NI le <script> inline qui definit _RSConfig (config produit) NI
   le <script> appstle-subscription.min.js -> widget absent "une fois sur 2".
   On detecte la navigation (sessionStorage) puis on reclone les DEUX
   scripts du helper block (inline _RSConfig d'abord, puis le script externe,
   meme URL -> cache -> execution rapide) pour forcer le rendu. */
(function() {
  window.__appstleFixV8 = true;
  var isProductPage = /\/products\//.test(location.pathname);
  var prevUrl = sessionStorage.getItem('__appstle_prev_url') || '';
  sessionStorage.setItem('__appstle_prev_url', location.href);
  var isNav = isProductPage && prevUrl && prevUrl !== location.href && /\/products\//.test(prevUrl);
  var cloned = false;

  function widgetVisible() {
    var widget = document.querySelector('[id^="appstle_subscription_widget"]');
    return !!(widget && widget.getBoundingClientRect().height > 0 && getComputedStyle(widget).display !== 'none');
  }

  function tryClone() {
    if (cloned || widgetVisible()) return;
    var block = document.querySelector('.shopify-block[id*="104366"]');
    if (!block) return;
    var rsScript = null, extScript = null;
    var scripts = block.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var t = scripts[i].textContent || '';
      var src = scripts[i].src || '';
      if (!rsScript && t.indexOf('_RSConfig') !== -1) rsScript = scripts[i];
      if (!extScript && src.indexOf('appstle-subscription.min.js') !== -1) extScript = scripts[i];
    }
    if (rsScript || extScript) {
      cloned = true;
      if (rsScript) { var s1 = document.createElement('script'); s1.textContent = rsScript.textContent; document.body.appendChild(s1); }
      if (extScript) { var s2 = document.createElement('script'); s2.src = extScript.src; s2.async = true; document.body.appendChild(s2); }
    }
  }

  if (isNav) {
    var mo = new MutationObserver(function() { tryClone(); });
    mo.observe(document.body, { childList: true, subtree: true });
    tryClone();
    setTimeout(tryClone, 2000);
    setTimeout(tryClone, 5000);
  }
})();


/* ── Panier latéral au-dessus du chat Gorgias ──
   Gorgias (#cst-shadow-host) est en z-index 2147483647 (max) : impossible de le
   battre par z-index. On masque le widget quand le drawer est ouvert (classe
   'active' sur <cart-drawer>) et on le restaure a la fermeture. */
(function () {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  function toggleGorgias() {
    var host = document.getElementById('cst-shadow-host');
    if (!host) return;
    host.style.display = drawer.classList.contains('active') ? 'none' : 'block';
  }
  new MutationObserver(toggleGorgias).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  /* Gorgias charge en async : si le host apparait apres, re-verifier */
  new MutationObserver(function () {
    if (document.getElementById('cst-shadow-host')) toggleGorgias();
  }).observe(document.body, { childList: true, subtree: true });
  toggleGorgias();
})();
